import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class DutyPaymentsUgService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get unpaid duties
   */
  getUnpaidDuties(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/get-unpaid-duties/ug`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get unpaid duties total
   */
  getUnpaidDutiesTotal(){

    let apiURL:string=`${this.baseURL}/v1/get-unpaid-duties-total/ug`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Save duty payment
   */
  addDutyPayment(duty_payment_data:any,selected_duties: any,total_amount_paid:any):Observable<any>{
    const formData = new FormData();
    formData.append("total_amount_paid", total_amount_paid);
    formData.append("payment_date", duty_payment_data.payment_date);
    formData.append("bank_account", duty_payment_data.bank_account);
    formData.append("selected_duties", JSON.stringify(selected_duties));

    let apiURL:string=`${this.baseURL}/v1/add-duty-payment/ug`;

    return this.http.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get Entry & Assessment Notice URL
   * @param entry_id
   */
  getEntryAndAssessmentNotice(entry_id:string){

    let apiURL:string=`${this.baseURL}/v1/get-im4-entry-url/${entry_id}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
